import React, { useState } from "react";
import Icontec from "../components/assets/img/LOGO-Icontec-2019_hor_white (1).png";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-free/css/all.min.css";
import instructivo from "../components/Document/Instructivo.pdf";

import {
  faCog,
  faPencil,
  faChess,
  faMobile,
  faQuestion,
} from "@fortawesome/free-solid-svg-icons";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons"

import CertiLink from "../components/assets/img/Designer 1.jpeg";
function Home() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  return (
    <div>
      {/* Menú interactivo */}
      <main className="main">
        {/* Hero Section */}
        <section id="hero" className="hero section dark-background">
          <div className="container">
            <div className="row gy-4">
              <div
                className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center"
                data-aos="zoom-out"
              >
                <h1>Mesas De Ayuda</h1>
              </div>

              <div
                className="col-lg-6 order-1 order-lg-2 hero-img"
                data-aos="zoom-out"
                data-aos-delay={100}
              >
                <img
                  src={Icontec}
                  className="img-fluid animated"
                  width={500}
                  alt="Icontec Logo"
                />
              </div>
            </div>
          </div>
        </section>

        <br />

        {/* Services Section - Browsers */}
        <section
          id="services"
          className="services section light-background py-5"
        >
          <div className="container section-title" data-aos="fade-up">
            <h2 className="text-center mb-4">
              Haga clíc sobre el nombre para acceder:
            </h2>
          </div>
          <div className="container">
            <div className="row gy-2 justify-content-center">
              {/* Tecnologia */}
              <div className="col-lg-3 col-md-3 d-flex mx-1" data-aos="fade-up">
                <div className="card service-item text-center shadow-sm p-3 card-smal">
                  <div className="icon mb-2">
                    <FontAwesomeIcon
                      icon={faMobile}
                      size="3x"
                      className="icon-custom-color"
                    />
                  </div>
                  <h4>
                    <a
                      className="benefits"
                      href="https://oracle.icontec.org/ords/r/iconmesatics/mesa-de-ayuda-tecnologia/login?session=214563208601113"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Tecnologia
                    </a>
                  </h4>
                </div>
              </div>
              

              {/* Abastecimiento */}
              <div className="col-lg-3 col-md-3 d-flex mx-1" data-aos="fade-up">
                <div className="card service-item text-center shadow-sm p-3">
                  <div className="icon mb-2">
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      size="3x"
                      className="icon-custom-color"
                    />
                  </div>
                  <h4>
                    <h4>
                      <a
                        className="benefits"
                        href="https://helpdesk.icontec.org:8443/front/login.php"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        GLPI
                      </a>
                    </h4>
                  </h4>
                </div>
              </div>

              <div className="col-lg-3 col-md-3 d-flex mx-1" data-aos="fade-up">
                <div className="card service-item text-center shadow-sm p-3">
                  <div className="icon mb-2">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      size="3x"
                      className="icon-custom-color"
                    />
                  </div>
                  <h4>
                    <h4>
                      <a
                        className="benefits"
                        href="https://oracle.icontec.org/ords/r/iconcartera/mesa-de-ayuda-cartera/login"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Tesoreria y cartera
                      </a>
                    </h4>
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <hr/>
          

          <hr />

          <div className="container">
            <div className="row gy-4">
              {/* Tecnologia */}

              {/* Abastecimiento */}
              <div
                className="col-lg-6 col-md-6 d-flex align-items-stretch"
                data-aos="fade-up"
              >
                <div className="card service-item text-center shadow-sm p-4">
                  <div className="icon mb-3">
                    <FontAwesomeIcon
                      icon={faCog}
                      size="3x"
                      className="icon-custom-color"
                    />
                  </div>
                  <h4>
                    <a
                      className="benefits"
                      href="https://oracle.icontec.org/ords/r/iconmesaabastecimientoprd/mesa-de-ayuda-abastecimiento/login?session=206247363268246"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Abastecimiento
                    </a>
                  </h4>
                  {/** 
                  <h4>
                    <a
                      className="benefits"
                      href="https://www.abastecimiento.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Abastecimiento
                    </a>
                  </h4>
                  */}
                </div>
              </div>

              {/* Contabilidad */}
              <div
                className="col-lg-6 col-md-6 d-flex align-items-stretch"
                data-aos="fade-up"
              >
                <div className="card service-item text-center shadow-sm p-4">
                  <div className="icon mb-3">
                    <FontAwesomeIcon
                      icon={faPencil}
                      size="3x"
                      className="icon-custom-color"
                    />
                  </div>
                  <h4>
                    <a
                      className="benefits"
                      href="https://oracle.icontec.org/ords/r/iconmesacontabilidadprd/mesa-de-ayuda-contabilidad/login?session=212795452546140"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Contabilidad
                    </a>
                  </h4>
                  {/** 
                  <h4>
                    <a
                      className="benefits"
                      href="https://www.contabilidad.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Contabilidad
                    </a>
                  </h4>
                  */}
                </div>
              </div>

              {/* Tesorería y Cartera */}
              <div
                className="col-lg-4 col-md-6 d-flex align-items-stretch"
                data-aos="fade-up"
              ></div>
            </div>
          </div>
          <br></br>
          <a
            className="btn-instructivo"
            href={instructivo}
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar Instructivo
          </a>
        </section>
        <hr />
      </main>

      <section id="services" className="services section light-background py-5">
        <div className="container">
          <div className="row gy-12 justify-content-center">
            {" "}
            {/* Centrar la fila */}
            {/* Certilink */}
            <div
              className="col-lg-3 col-md-3 d-flex align-items-stretch mx-auto"
              data-aos="fade-up"
            >
              <div className="card service-item text-center shadow-sm p-4 card-small">
                <div className="icon">
                  <img src={CertiLink} alt="WinRAR Icon" width="114" />
                </div>
                <h4>
                  <a
                    className="benefits"
                    href="https://oracle.icontec.org/ords/r/iconmesaut/mesa-de-ayuda-sistema-de-gestion/login?session=215604699488297"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Certilink
                  </a>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      <a
        href="#"
        id="scroll-top"
        className="scroll-top d-flex align-items-center justify-content-center"
      >
        <i className="fas fa-arrow-up" />{" "}
      </a>
    </div>
  );
}

export default Home;
